/** [發票開立方式] 與 component 對應關係 */
export const componentLut = {
  '01': 'electronic-invoice',
  '04': 'donate-invoice',
  '05': 'paper-invoice',
};
